import React from 'react';
import { useField } from 'formik';

interface Option {
  value: string;
  label: string;
}

interface ChedaGamingSelectProps {
  name: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  icon?: React.ReactNode;
  className?: string;
  options?: Option[];
  onChange?: React.ChangeEventHandler<HTMLSelectElement>;
  onBlur?: React.FocusEventHandler<HTMLSelectElement>;
  value?: any;
  error?: string | undefined;
  touched?: boolean;
}

const ChedaGamingSelect: React.FC<ChedaGamingSelectProps> = ({
  name,
  label,
  placeholder,
  required = false,
  disabled = false,
  icon,
  className,
  options = [],
  onChange,
  onBlur,
  value,
  error,
  touched,
}) => {
  const [field, meta, helpers] = useField(name);

  const handleLocalChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    helpers.setValue(e.target.value);
  };

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (onChange) onChange(e);
    handleLocalChange(e);
  };

  const handleBlur = (e: React.FocusEvent<HTMLSelectElement>) => {
    if (onBlur) onBlur(e);
    field.onBlur(e as any);
  };

  const inputValue = value !== undefined ? value : field.value;
  const showError = (touched ?? meta.touched) && (error ?? meta.error);

  return (
    <div className={`form-group ${className || ''}`}>
      {label && <label className="form-label">{label}</label>}
      <div className="input-container">
        {icon}
        <select
          {...field}
          value={inputValue}
          onChange={handleChange}
          onBlur={handleBlur}
          required={required}
          disabled={disabled}
          className="form-input"
        >
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
      {showError && <div className="input-error">{(error ?? meta.error) as string}</div>}
    </div>
  );
};

export default ChedaGamingSelect;
